"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[300],{

/***/ 50300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Survey": function() { return /* binding */ Survey; },
  "SurveyContainer": function() { return /* binding */ SurveyContainer; },
  "shuffledOptions": function() { return /* binding */ shuffledOptions; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(47925);
// EXTERNAL MODULE: ../../node_modules/@zapier/toolbox-tracking/dist/index.js
var dist = __webpack_require__(24645);
// EXTERNAL MODULE: ../../node_modules/@zapier/theme/esm/Zindexes.js
var Zindexes = __webpack_require__(27664);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Surface/Surface.js
var Surface = __webpack_require__(99570);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Icon/Icon.js + 1 modules
var Icon = __webpack_require__(46688);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/display/Text/Text.js
var Text = __webpack_require__(55414);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/forms/BooleanInput/LabeledRadio.js
var LabeledRadio = __webpack_require__(56050);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/components/navigation/Button/Button.js
var Button = __webpack_require__(20110);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Typography.js
var Typography = __webpack_require__(3000);
// EXTERNAL MODULE: ../../node_modules/@zapier/design-system/esm/theme/Colors.js
var Colors = __webpack_require__(99029);
// EXTERNAL MODULE: ./src/constants/responsive.ts
var responsive = __webpack_require__(95964);
// EXTERNAL MODULE: ./src/hooks/useViewportSize.tsx
var useViewportSize = __webpack_require__(36287);
// EXTERNAL MODULE: ./src/observability/tracking/avro.ts
var avro = __webpack_require__(90073);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/zodParse.ts
var zodParse = __webpack_require__(93475);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs + 1 modules
var core_dist = __webpack_require__(79381);
;// CONCATENATED MODULE: ./src/rest/zapier/index.ts





var BASE_URL = "".concat("https://zapier-staging.com", "/api/v4");

// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ./src/rest/zapier/identity/types.ts

var Z_Identity = lib.z.object({
    has_signed_up: lib.z.boolean(),
    identity: lib.z.number(),
    is_logged_in: lib.z.boolean()
});

;// CONCATENATED MODULE: ./src/rest/zapier/identity/data.ts






var useIdentity = function() {
    return (0,core_dist/* default */.ZP)("/api/v4/identity", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, json;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat(BASE_URL, "/identity/"));
                case 2:
                    response = _ctx.sent;
                    _ctx.next = 5;
                    return response.json();
                case 5:
                    json = _ctx.sent;
                    (0,zodParse/* zodParse */.U)(Z_Identity, json, "Identity");
                    return _ctx.abrupt("return", json);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
};

// EXTERNAL MODULE: ../../node_modules/@splitsoftware/splitio-react/es/SplitContext.js
var SplitContext = __webpack_require__(24497);
// EXTERNAL MODULE: ../../node_modules/@splitsoftware/splitio-react/es/useTreatments.js + 1 modules
var useTreatments = __webpack_require__(14437);
;// CONCATENATED MODULE: ./src/components/Survey/usePopupSurvey.ts


var SPLITIO_FEATURE_NAME = "atc_pagebuilder_popup_survey";
var SPLITIO_CONTROL_TREATMENT_KEY = "on";
function usePopupSurvey() {
    var isReady = (0,react.useContext)(SplitContext/* default */.Z).isReady;
    var treatments = (0,useTreatments/* default */.Z)([
        SPLITIO_FEATURE_NAME
    ]);
    var treatment = treatments[SPLITIO_FEATURE_NAME].treatment;
    return {
        isReady: isReady,
        isActive: treatment === SPLITIO_CONTROL_TREATMENT_KEY
    };
}

;// CONCATENATED MODULE: ./src/hooks/useLocalStorage.ts

function useLocalStorage(key) {
    var ref = (0,react.useState)(function() {
        try {
            var item = localStorage.getItem(key);
            if (item) {
                return JSON.parse(item);
            }
            return null;
        } catch (e) {
            // Could not get the item from LocalStorage
            return null;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(value) {
        try {
            var valueToStore = value;
            setStoredValue(valueToStore);
            localStorage.setItem(key, JSON.stringify(valueToStore));
            return valueToStore;
        } catch (error) {
            // Could not set value in LocalStorage
            return null;
        }
    };
    return [
        storedValue,
        setValue
    ];
}
/* harmony default export */ var hooks_useLocalStorage = (useLocalStorage);

// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/readCookie.js
var readCookie = __webpack_require__(59251);
// EXTERNAL MODULE: ../../node_modules/@zapier/cookies/esm/writeCookie.js
var writeCookie = __webpack_require__(26791);
// EXTERNAL MODULE: ../../node_modules/@splitsoftware/splitio-react/es/SplitFactory.js + 1 modules
var SplitFactory = __webpack_require__(63217);
// EXTERNAL MODULE: ./src/utils/isBrowser.ts
var isBrowser = __webpack_require__(82929);
;// CONCATENATED MODULE: ./src/components/SplitioProvider.tsx





var SplitioProvider = function(param) {
    var children = param.children;
    var zapidentity = (0,readCookie/* readCookie */.v)("zapidentity");
    var zapSplitKey = (0,readCookie/* readCookie */.v)("__zsk");
    var ref = (0,react.useState)(zapSplitKey || zapidentity), key = ref[0], setkey = ref[1];
    var intervalIndex = (0,react.useRef)(0);
    var pollForZapidentity = function() {
        var intervalID = setInterval(function() {
            intervalIndex.current += 1;
            var cookie = (0,readCookie/* readCookie */.v)("zapidentity");
            if (cookie) {
                setkey(cookie);
                clearInterval(intervalID);
            } else if (intervalIndex.current >= 24) {
                var ref;
                /**
         * If zapidentity isn't available for some reason, we create a uuid and use that as the split key.
         * If the user has not consented to analytics cookies, then we set the split key to be 'anonymous_group'.
         */ var uuid;
                if ((ref = window.crypto) === null || ref === void 0 ? void 0 : ref.randomUUID) {
                    uuid = window.crypto.randomUUID();
                } else {
                    // Slice off "0." from the Math.randomw() string
                    uuid = String(Math.random()).slice(2);
                }
                var success = (0,writeCookie/* writeCookie */.w)("__zsk", uuid, {
                    category: "analytics",
                    maxAge: 365
                });
                setkey(success ? uuid : "anonymous_group");
                clearInterval(intervalID);
            }
        }, 2);
        return intervalID;
    };
    (0,react.useEffect)(function() {
        if (!(0,isBrowser/* isBrowser */.j)()) return;
        var intervalID;
        /**
     * zapidentity is not available initially for first time visitors.
     * Because we can't listen for cookie changes, we need to poll for the cookie.
     * This is similar to how we are waiting for the cookie in TrackingRouting.tsx.
     */ if (!key) {
            intervalID = pollForZapidentity();
        }
        return function() {
            if (intervalID) {
                clearInterval(intervalID);
            }
        };
    }, [
        key
    ]);
    if (!key) return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitFactory/* default */.Z, {
        config: {
            core: {
                authorizationKey: "er39tqoto8kar2h0n7dkdvc85p3bcubnt5so" || 0,
                key: key
            }
        },
        updateOnSdkUpdate: true,
        updateOnSdkTimedout: true,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/Survey/Survey.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bottom: -8px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  right: 50px;\n  z-index: ",
        ";\n\n  @media screen and (max-width: 565px) {\n    right: 50%;\n    transform: translateX(50%);\n  },\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    padding: 25px 15px 0;\n    max-width: 95vw;\n    width: 330px;\n    padding-bottom: ",
        ";\n\n    ",
        " {\n      padding-bottom: 0;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 10px;\n  top: 10px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 5px;\n  background-color: transparent;\n  outline: none;\n  border: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 30px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: initial;\n  display: grid;\n  justify-items: center;\n  min-height: 190px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 20px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n  margin-left: -15px;\n  margin-right: -15px;\n  padding: 20px 15px 33px 15px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  margin-bottom: 0;\n  padding-left: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
















var shuffledOptions = (0,lodash.shuffle)([
    {
        id: "search-engine",
        label: "Search engine"
    },
    {
        id: "facebook-instagram",
        label: "Facebook/ Instagram"
    },
    {
        id: "website-referral",
        label: "Website Referrals"
    },
    {
        id: "podcast",
        label: "Podcast"
    },
    {
        id: "word-of-mouth",
        label: "Word of mouth"
    },
    {
        id: "linkedin",
        label: "LinkedIn"
    },
    {
        id: "youtube",
        label: "YouTube"
    },
    {
        id: "billboard",
        label: "Billboard"
    }, 
]);
var EXPERIMENT_NAME = "popup-survey";
var SURVEY_EVENTS = {
    shown: "shown",
    dismissed: "dismissed",
    completed: "completed"
};
var Survey = function() {
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        var option = options.find(function(option) {
            return option.id === selectedOption;
        });
        if (!option) return;
        try {
            trackEvent("".concat(EXPERIMENT_NAME, ":").concat(SURVEY_EVENTS.completed), {
                response: option.id
            });
            emitUserInteractionEvent({
                event_action: avro/* EventAction.click */.AO.click,
                interaction_name: avro/* InteractionName.submit */.AI.submit,
                interaction_raw_text: "Submit",
                option_selected: "submit",
                interaction_goal: "survey",
                custom_tracking_fields: {
                    responseID: option.id,
                    responseLabel: option.label,
                    component: "Survey"
                }
            });
        } catch (error) {
            (0,esm_exports/* captureException */.Tb)(error);
        } finally{
            setShowSuccessMessage(true);
            setShowPopupFromLocalStorage(false);
        }
    };
    var popupSurvey = usePopupSurvey();
    var ref = (0,_sliced_to_array/* default */.Z)(hooks_useLocalStorage("zapier__popup-survey"), 2), showPopupFromLocalStorage = ref[0], setShowPopupFromLocalStorage = ref[1];
    var ref1 = (0,react.useState)(false), showSuccessMessage = ref1[0], setShowSuccessMessage = ref1[1];
    var data = useIdentity().data;
    var width = (0,useViewportSize/* useViewportSize */.n)().width;
    var emitUserInteractionEvent = (0,avro/* useAvroTracking */.B2)().emitUserInteractionEvent;
    var trackEvent = (0,dist.useTrackingContext)().trackEvent;
    var isMobile = width === "small" || width === "extraSmall";
    var ref2 = (0,react.useState)(""), selectedOption = ref2[0], setSelectedOption = ref2[1];
    // Begin as collapsed for small only.
    var ref3 = (0,react.useState)(isMobile), isCollapsed = ref3[0], setIsCollapsed = ref3[1];
    // Once expanded, it may not be collapsed again.
    var expandSurvey = function() {
        setIsCollapsed(false);
    };
    (0,react.useEffect)(function() {
        setIsCollapsed(isMobile);
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        emitUserInteractionEvent({
            event_action: avro/* EventAction.in_view */.AO.in_view,
            interaction_name: avro/* InteractionName.popup */.AI.popup,
            option_selected: "survey",
            custom_tracking_fields: {
                component: "Survey"
            }
        });
        trackEvent("".concat(EXPERIMENT_NAME, ":").concat(SURVEY_EVENTS.shown));
    }, [
        emitUserInteractionEvent,
        trackEvent
    ]);
    var options = (0,_to_consumable_array/* default */.Z)(shuffledOptions).concat([
        {
            id: "other",
            label: "Other"
        }, 
    ]);
    var handleSelectOption = function(e) {
        var ref;
        var target = e.target;
        var value = target.value;
        setSelectedOption(value);
        emitUserInteractionEvent({
            event_action: avro/* EventAction.select */.AO.select,
            interaction_name: avro/* InteractionName.radio_select */.AI.radio_select,
            interaction_raw_text: (ref = options.find(function(option) {
                return option.id === target.id;
            })) === null || ref === void 0 ? void 0 : ref.label,
            option_selected: "radio",
            interaction_goal: "survey",
            custom_tracking_fields: {
                component: "Survey"
            }
        });
    };
    var handleDismissClick = function() {
        setShowSuccessMessage(false);
        setShowPopupFromLocalStorage(false);
        emitUserInteractionEvent({
            event_action: avro/* EventAction.close */.AO.close,
            interaction_name: avro/* InteractionName.dismiss */.AI.dismiss,
            interaction_raw_text: "Close the survey",
            option_selected: "dismiss_button",
            interaction_goal: "survey",
            custom_tracking_fields: {
                component: "Survey"
            }
        });
        trackEvent("".concat(EXPERIMENT_NAME, ":").concat(SURVEY_EVENTS.dismissed));
    };
    var showSurvey = showSuccessMessage || showPopupFromLocalStorage === null && (data === null || data === void 0 ? void 0 : data.has_signed_up) === false && popupSurvey.isReady && popupSurvey.isActive;
    if (!showSurvey) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Surface/* Surface */.T, {
            backgroundColor: "white",
            borderColor: "gray20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                isCollapsed: isCollapsed,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                onClick: handleDismissClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    ariaLabel: "Close the survey",
                                    color: "gray60",
                                    name: "formX",
                                    size: 25
                                })
                            }),
                            !showSuccessMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                fontWeight: 700,
                                tag: "h2",
                                type: "paragraph1Short",
                                children: "What brought you to us today?"
                            })
                        ]
                    }),
                    isCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButton, {
                        onClick: expandSurvey,
                        children: "(tap to answer)"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
                        onSubmit: handleSubmit,
                        children: [
                            showSuccessMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        color: "success",
                                        name: "formCheckCircle",
                                        size: 60
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        tag: "h2",
                                        textAlign: "center",
                                        type: "pageHeader5",
                                        children: "Thank you"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlsWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fieldset, {
                                    children: options.map(function(option) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabeledRadio/* LabeledRadio */.F, {
                                            tabIndex: 0,
                                            onChange: handleSelectOption,
                                            name: "mp-survey",
                                            value: option.id,
                                            id: option.id,
                                            checked: option.id === selectedOption,
                                            children: option.label
                                        }, option.id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitWrapper, {
                                children: showSuccessMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    isFullWidth: true,
                                    onClick: function() {
                                        return setShowSuccessMessage(false);
                                    },
                                    size: "small",
                                    type: "button",
                                    children: "Close"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    disabled: !selectedOption,
                                    isFullWidth: true,
                                    size: "small",
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var Container = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), Zindexes/* Zindexes.fixedSurvey */.C.fixedSurvey);
var Content = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var isCollapsed = param.isCollapsed;
    return [
        (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), isCollapsed ? "25px" : 0, responsive/* mediaQueries.tablet */.w5.tablet), 
    ];
});
var Header = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var CloseButton = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var ExpandButton = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject4(), Typography/* Typography.smallPrint1 */.ZT.smallPrint1, Colors/* Colors.blueJeans */.w.blueJeans);
var Form = emotion_styled_browser_esm/* default.form */.Z.form(_templateObject5());
var SuccessWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
var ControlsWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject7());
var SubmitWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8(), Colors/* Colors.gray5 */.w.gray5, Colors/* Colors.gray20 */.w.gray20);
var Fieldset = emotion_styled_browser_esm/* default.fieldset */.Z.fieldset(_templateObject9());
var SurveyContainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitioProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {})
    });
};


/***/ })

}]);